import React from "react";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { FilterableTablePayables } from "../components/TablePayables/FilterableTablePayables";

export const RoutePayablesScheduled: React.FC = () => {
  useBrowserPageTitle("Scheduled Payables");

  return (
    <FilterableTablePayables
      tab="scheduled"
      showDownloadCsv
      bulkActions={["unapprove", "cancel"]}
      visibleColumns={{
        payee: true,
        payableNumber: true,
        amount: true,
        dueDate: true,
        status: true
      }}
      visibleFilters={{
        payeeId: true,
        openedDateRange: true,
        dueDateRange: true
      }}
      emptyState={{
        firstTime:
          "Approved payments will queue here before they are paid in the next payroll cycle.",
        standart: "No approved payments for the next payroll cycle."
      }}
    />
  );
};
